import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_849_31903)">
      <path
        d="M0.833252 2.91683C0.833252 1.76624 1.76599 0.833496 2.91659 0.833496H15.4166C16.5672 0.833496 17.4999 1.76624 17.4999 2.91683V15.4168C17.4999 16.5674 16.5672 17.5002 15.4166 17.5002H2.91659C1.76599 17.5002 0.833252 16.5674 0.833252 15.4168V2.91683Z"
        fill="#38D695"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.22929 3.95605C7.02154 3.95605 6.85313 4.12447 6.85313 4.33221V4.95987H7.60544V4.70837H10.8918V4.95987H11.6441V4.33221C11.6441 4.12447 11.4757 3.95605 11.268 3.95605H7.22929ZM5.50693 6.21519C5.50693 6.00744 5.67534 5.83903 5.88309 5.83903H12.6142C12.822 5.83903 12.9904 6.00744 12.9904 6.21519V6.84285H12.2381V6.59135H6.25924V6.84285H5.50693V6.21519ZM4.53687 13.5924V8.25283C4.53687 8.04535 4.62733 7.84636 4.78835 7.69964C4.94937 7.55293 5.16776 7.4705 5.39548 7.4705H12.9375C13.1652 7.4705 13.3836 7.55293 13.5446 7.69964C13.7057 7.84636 13.7961 8.04535 13.7961 8.25283V13.5924C13.7961 13.7999 13.7057 13.9989 13.5446 14.1456C13.3836 14.2923 13.1652 14.3747 12.9375 14.3747H5.39548C5.16776 14.3747 4.94937 14.2923 4.78835 14.1456C4.62733 13.9989 4.53687 13.7999 4.53687 13.5924ZM12.9375 9.03516H8.61528H5.39548V13.5924H12.9375V9.03516Z"
        fill="white"
      />
      <ellipse
        cx={14}
        cy={14}
        rx={5}
        ry={5}
        fill="#37363F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5472 14.1439V14.0505C16.5471 14.0068 16.5357 13.9638 16.514 13.9258C16.4924 13.8878 16.4613 13.856 16.4237 13.8336L13.4903 12.1182C13.2567 11.9814 13.1632 11.9814 13.0831 12.0281L12.9997 12.0748C12.9622 12.0973 12.9311 12.129 12.9094 12.1671C12.8878 12.2051 12.8764 12.248 12.8762 12.2918V15.9027C12.8775 15.9453 12.8895 15.9869 12.911 16.0236C12.9326 16.0604 12.9631 16.0911 12.9997 16.1129L13.0831 16.1597C13.1632 16.2064 13.2567 16.2064 13.4369 16.0996L16.4237 14.3609C16.4613 14.3384 16.4924 14.3067 16.514 14.2686C16.5357 14.2306 16.5471 14.1877 16.5472 14.1439Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_849_31903">
        <rect
          width={18}
          height={18}
          fill="white"
          transform="translate(1 1)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgPlaybookPresentTab = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgPlaybookPresentTab;
